export type SortOrder = 'asc' | 'desc';

export type SortOrderOptional = SortOrder | undefined;

export const isSortOrder = (value: unknown): value is SortOrder =>
  value === 'asc' || value === 'desc';

/**
 * The warning is development-only: `order` arrives from the URL, where anything can be typed, and
 * falling back in silence hides a bug in the code that writes the query.
 */
export function toSortOrder(value: string, fallback: SortOrder = 'asc'): SortOrder {
  if (isSortOrder(value)) {
    return value;
  }
  if (process.env.NODE_ENV === 'development') {
    console.warn(`Invalid sort order: "${value}". Using fallback: "${fallback}"`);
  }
  return fallback;
}
